var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageIcon = function SvgImageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 15,
    x: 3.5,
    y: 4.5,
    stroke: "#3AACC8",
    strokeWidth: 1.6,
    rx: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 10,
    r: 1.6,
    stroke: "#3AACC8",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M4.5 17 9 13l3.5 3 3-2.5 4 3.5"
  })));
};
export { SvgImageIcon as ReactComponent };
export default __webpack_public_path__ + "8d1ad8f673ddef65fb4bfc2694845661.svg";